import styled, { css } from 'styled-components';
import { IPropsStyles as ContainerProps } from '.';

export const Container = styled.section<ContainerProps>`
  .containerContent {
    position: fixed;
    display: flex;
    flex-direction: column;
    width: 60%;
    height: auto !important;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 2;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    color: white;
    backdrop-filter: blur(3px);
    background: ${({ theme }) => theme.colors.primary};
    background: linear-gradient(
      34deg,
      ${({ theme }) => theme.colors.primary} 8%,
      ${({ theme }) => theme.colors.secondary} 95%
    );

    opacity: 0;
    pointer-events: none;
    transform: translateY(50px);
    transition: 0.5s;

    .content {
      width: 100%;
      height: 100%;
      overflow-y: scroll;
      overflow-x: hidden;

      ::-webkit-scrollbar {
        display: none;
      }

      .header {
        position: absolute;
        top: 0;
        right: 0;
      }

      .close {
        cursor: pointer;
        transform: rotate(45deg);
        transition: 0.7s;
      }

      nav {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        transform: scale(0.7);
        transition: 0.7s;

        ul {
          list-style: none !important;
          margin: 0;
          padding: 0;

          li {
            padding: 13px 0px;

            a {
              font-size: 20px;
              text-decoration: none;
              color: inherit;
            }
          }
        }
      }
    }

    ${({ isVisible }) =>
      isVisible &&
      css`
        opacity: 1;
        pointer-events: auto;
        transform: translateY(0px);

        .content {
          .close {
            transform: rotate(0deg);
          }

          nav {
            transform: scale(1);
          }
        }
      `}

    @media(max-width: 310px) {
      padding: 1.5rem;
    }
  }

  ${({ isVisible }) =>
    isVisible &&
    css`
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 2;
      background: ${({ theme }) => theme.colors.background};
    `}
`;
